import { Component, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { LocationService } from '../../services/location.service';
import { ProductionOrderService } from '../../services/productionOrders.service';
import { PalletsService } from '../../services/pallets.service';
import { Pallets } from '../../model/Pallets';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { FilterUrlService } from '../../services/filter-url.service';

@Component({
  selector: 'pallets',
  templateUrl: './pallets.component.html',
  styleUrls: ['./pallets.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class PalletsComponent implements OnInit {
  @ViewChild(ModalDirective) public lgModal: ModalDirective;
  public load:number;
  public primeracarga:boolean;
  public isopen:boolean;
  public alert:string;
  public data_list:any;
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public item_to_update:number;
  public ordenesproduccion:any[];
  public locaciones:any[];
  public posiciones:any[] ;
  public myAngularxQrCode: string;
  public ubicacion:string;
  public posicion:string;
  public detalles: any[];
  public ordendeproduccion:string;
  public numerodecajas:number;
  public codigo:string;
  public settings = {
    columns:{
      number: {header: "Numero", type:"text",filter: { visible:true }},
      qr_code: {header: "Codigo QR", type:"text",filter: { visible:false }},
      amount: {header: "Cantidad", type:"text",filter: { visible:false }},
      location:{header:"Ubicación", type:"obj",tipo:"location", path:"relationships.position.data.attributes.location",filter: { visible:false }},
      position:{header:"Posición", type:"obj", tipo:"position", path:"relationships.position.data.attributes.name",filter: { visible:false }},
      block:{header:"Estado", type:"text",filter: { visible:false }}
    },
    actions:{
      edit: false,
      view: true,
      delete: false
    }
  };

  constructor(private _locationService:LocationService,
    private _productionorderService:ProductionOrderService,
    private _localeService: BsLocaleService,
    private _palletsService:PalletsService,
    private _loaddata: LoadService,
    private _filter: FilterUrlService) {
    this.isopen = false;
    this.alert = "";
    this.primeracarga = false;
    this.ordenesproduccion = [];
    this.locaciones = [];
    this.posiciones = [];
    this.myAngularxQrCode= 'P18-0000';
    this.ubicacion = '';
    this.posicion = '';
    this.detalles = [];
    this.ordendeproduccion = '';
    this.numerodecajas = 0;
    this.codigo = '';
  }

  ngOnInit() {
    this._loaddata.loadChange(15);
    this._localeService.use('es');
    this._filter.filterFirstLoad(this.settings);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'orden': new FormControl(null,Validators.required),
      'idorden': new FormControl(null,Validators.required),
      'prefijo': new FormControl(null,Validators.required),
      'codigo': new FormControl(null),
      'cliente': new FormControl(null),
      'qr': new FormControl('')
    });
    this.loadLocaciones();
  }
  /**
  * carga el listado de todas las ubicaciones
  */
  loadLocaciones():void{
    this._loaddata.loadChange(30);
    this._locationService.get().subscribe((response:any) => {
      this.locaciones = response.data;
      this.loadData();
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  loadDataFiltered(filters){
    this.isopen = true;
    this.alert = 'Cargando información';
    this._loaddata.loadChange(50);
    this._palletsService.getDataFiltered(filters)
    .subscribe(
      (response:any) => {
        this.cleanForm();
        this.data_list = response.data;
        //console.log("RESPUESTA FILTROS: ", this.data_list);
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

/**
 * Carga el listado de informacion.
 */
  loadData():void{
    this.isopen = true;
    this.alert = 'Cargando información';
    this._loaddata.loadChange(50);
    this._palletsService.get().subscribe(
      (response:any) => {
        this.cleanForm();
        this.data_list = response.data;
        //console.log("DATALIST: ", this.data_list);
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

/**
 * Carga la información de una fila en el formulario.
 * @param  index Indice de la fila que se carga en el formulario.
 */
  showViewForm(index) {
    this.codigo = '';
    this.detalles = [];
    this.posicion = '';
    this.ubicacion = '';
    this.title = '';
    this.isNew = false;
    this.isopen = false;
    this.item_to_update = index;
    this._loaddata.loadChange(30);
    this._palletsService.getPalletDetails(this.data_list[index].id).subscribe(
      (response:any) => {
        //console.log("DETALLES DEL PALLET: ", response);
        for(let fila of response.data){
          this.detalles.push(fila);
        }
        if(this.detalles.length != 0){
          this.posicion = this.detalles[0].attributes.position;
          this.ubicacion = this.detalles[0].attributes.location;
        }
        else{
          this.posicion = "Sin Posición";
          this.ubicacion = "Sin Ubicación";
        }

        this.ordendeproduccion = this.data_list[this.item_to_update].attributes.prefix.substr(1, (this.data_list[this.item_to_update].attributes.prefix.length-1));
        this.numerodecajas = this.data_list[this.item_to_update].attributes.amount;
        this.title = this.data_list[this.item_to_update].attributes.number;
        this._loaddata.loadChange(100);
        this.alert = "Carga correcta."
        this.isopen =true;
        this.lgModal.show();
        this.onClosedAutomatic();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  calculateTotalBoxes(valor1:string,valor2:string){
    return (parseInt(valor1)+parseInt(valor2));
  }

/**
 * Muestra el modal para crear o actualizar segun corresponda.
 * @param tipo si es crear o actualizar
 */
  showChildModal(): void {
    this.myAngularxQrCode = ' ';
    this.alert = "Cargando Ordenes de producción";
    this.title = "Crear Pallet";
    this.isNew = true;
    this.isopen = true;
    this._loaddata.loadChange(30);
    this.ordenesproduccion = [];
    this.cleanForm();

    this._productionorderService.getAllUndone().subscribe(
      (response:any) => {
        this.ordenesproduccion = response.data;
        this.alert = "Carga de ordenes de producción completa."
        this.lgModal.show();
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  onChangeOP(){
    let pallet = '';
    let orden = '';
    let cliente = '';
    for(let ops of this.ordenesproduccion){
      if(ops.id == this.signupForm.get('idorden').value){
        orden = ops.attributes.number;
        pallet = 'P'+ops.attributes.number;
        cliente = ops.relationships.client.data.attributes.name;
        break;
      }
    }

    this.signupForm.patchValue({
      'orden':orden,
      'prefijo': pallet,
      'cliente':cliente
    });
  }

  /**
   * Envia a la BD los datos del formulario.
   */
    saveForm():void{
      this.alert = "Creando Pallet";
      this.isopen =true;
      this._loaddata.loadChange(30);

      let prov = this._palletsService.transformData4(this.signupForm.get('prefijo').value);
      this._palletsService.save(prov).subscribe(
        (response:any) =>{

          this.myAngularxQrCode = response.attributes.qr_code;
          this.codigo = response.attributes.number;

          this.signupForm.patchValue({
            'codigo': response.attributes.number,
            'qr': response.attributes.qr_code
          });

          this._loaddata.loadChange(40);
          let that = this;
          setTimeout(function(){
            that.print();
          },100);
        },
        (error) => {
          this.showError(error.error.error);
        }
      );
    }

  /**
  * Abre una nueva ventana para imprimir las etiquetas QR contenidas
  * en printContents, que a su vez esta relacionado con print-section del html.
  */
  private print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
      <style></style>
      </head>
      <body onload="window.print();window.close()">
      ${printContents}
      </body>
      </html>`
    );
    popupWin.document.close();
    this.loadData();
    this.hideChildModal();
  }

/**
 * Cierra el modal
 */
  hideChildModal(): void {
    this.lgModal.hide();
    this.cleanForm();
  }

/**
 * Cierra el mensaje de alerta.
 */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 3000);

  }

/**
 * Muestra un error
 * @param  msg mensaje del error
 */
 showError(msg:string){
   if(msg == undefined){
     this.alert = 'No tiene permisos para realizar la acción.';
   }
   else{
     this.alert = msg;
   }
   this._loaddata.loadChange(100);
   this.isopen =true;
 }

/**
 * Limpia el formulario para volver a utilizarlo despues.
 */
  cleanForm():void{
    this.signupForm.reset();
    this.signupForm = new FormGroup({
      'orden': new FormControl(null,Validators.required),
      'idorden': new FormControl(null,Validators.required),
      'prefijo': new FormControl(null,Validators.required),
      'codigo': new FormControl(null),
      'cliente': new FormControl(null),
      'qr': new FormControl('')
    });
  }

/**
 * Actualiza el listado por la paginacion
 * @param data nuevo listado o mensaje de error.
 */
  updateData(data:any):void{
    if(data === "Error al cargar listado."){
      this.showError(data);
    }
    else{
      this.data_list = data;
    }
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/pallets/pallets.component.ts